<template>
    <div class="label nowrap user-avatar">
        <img 
          :src="image ? image : 'https://ui-avatars.com/api/?name=Default'" 
          alt="user avatar" 
          class="img-circle avatar">
        <router-link class="d-flex flex-column justify-center align-start info" :to="to" v-if="to">
          <h5 v-if="name.length>0" class="name">{{name}}</h5>
          <span v-if="email.length>0">{{email}}</span>
        </router-link>
        <div class="d-flex flex-column justify-center align-items-start info" v-else>
          <h5 v-if="name.length>0" class="name">{{name}}</h5>
          <span v-if="email.length>0">{{email}}</span> 
        </div>
    </div>
</template>
<script>
export default {
    name: 'UserAvatar',
    props: {
      image: {
        type: String,
        default:'https://ui-avatars.com/api/?name=Default'
      },
      name: {
        type:String,
        default: ''
      },
      email: {
        type:String,
        default: ''
      },
      to: {
        type:[String,Object],
        default: null
      },
    }
}
</script>
<style>
.user-avatar {
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  padding: 1px;
  color: #212529;
}
.user-avatar .avatar {
  height: 20px;
  width: 20px;
}
.user-avatar > .info {
  padding: 0 0.5rem;
}
.user-avatar > .info > .name {
  font-size: 0.65rem;
  margin: 0;
}
.user-avatar > .info > .email {
  font-size: 0.65rem;
}
</style>